export default __webpack_public_path__ + "static/land_malls-0f34c7fa6f50a859ba2f814991e1d87b.png";